import { StringMap } from '../common/interfaces/stringMap';

/** Page view : Path name */
export const GARouteMappings: StringMap = {
  START: '/experience/start',
  LOGIN: '/experience/login',
  RESET_PASSWORD: '/experience/reset-password',
  REGISTER: '/experience/register',
  FORGOT_PASSWORD: '/experience/forgot-password',
  USER_PROFILE: '/experience/user-profile',
  DPN: '/experience/dpn',
  APPLICATION_FORM: '/experience/application-form',
  EEO: '/experience/eeo',
  OFCCP: '/experience/ofccp',
  RESEARCH_QUESTIONS: '/experience/research-questions',
  YOUR_RESPONSIBILITIES: '/experience/your-responsibilities',
  RJP: '/experience/rjp',
  MINIMUM_QUALIFICATIONS: '/experience/minimum-qualifications',
  GENCONTENT: '/experience/general-content',
  TASKLIST: '/experience/task-list',
  END: '/experience/end',
  HURDLE_FAIL: '/experience/hurdle-fail',
  NOT_FOUND: '/experience',
  ASSESSMENT: '/experience/assessment',
  EXPVIDEOTASK: '/experience/video-task',
  SHL360_LOGIN: '/shl360/login',
  SHL360_FORGOT_PASSWORD: '/shl360/forgot-password',
  SHL360_RESET_PASSWORD: '/shl360/reset-password',
  SHL360_REGISTER: '/shl360/register',
  SHL360_BIODATA: '/shl360/bio-data',
  SHL360_TASKLIST: '/shl360/task-list',
  SHL360_START: '/shl360/start',
  SHL360_RATERLIST: '/shl360/rater-list',
  SHL360_QUESTIONS: '/shl360/questions',
  SHL360_VIEWALL: '/shl360/viewall',
  SHL360_THANKYOU: '/shl360/thankyou',
  SHL360_SEARCH: '/shl360/search',
  SHL360_ADD_RATER: '/shl360/add-rater',
  SHL360_PREVIEW: '/shl360/preview',
};

/** Page View : Title */
export const GAPageViewMappings: StringMap = {
  START: 'Experience: Workflow start',
  LOGIN: 'Experience: Login',
  RESET_PASSWORD: 'Experience: Reset password',
  REGISTER: 'Experience: Register',
  FORGOT_PASSWORD: 'Experience: Forgot password',
  USER_PROFILE: 'Experience: User profile',
  DPN: 'Experience: Data protection notice',
  EEO: 'Experience: EEO',
  OFCCP: 'Experience: OFCCP',
  RESEARCH_QUESTIONS: 'Experience: Research Questions',
  YOUR_RESPONSIBILITIES: 'Experience: Your Responsibilities',
  RJP: 'Experience: RJP',
  MINIMUM_QUALIFICATIONS: 'Experience: Minimum Qualifications',
  GENCONTENT: 'Experience: General content',
  TASKLIST: 'Experience: Task list',
  END: 'Experience: Assessment End',
  HURDLE_FAIL: 'Experience: Hurdle Failed',
  NOT_FOUND: 'Experience: Page not found',
  ASSESSMENT: 'Experience: Assessment',
  EXPVIDEOTASK: 'Experience: Video Task',
  SHL360_LOGIN: 'SHL360: Login',
  SHL360_FORGOT_PASSWORD: 'SHL360: Forgot password',
  SHL360_RESET_PASSWORD: 'SHL360: Reset password',
  SHL360_REGISTER: 'SHL360: Register',
  SHL360_BIODATA: 'SHL360: Bio data',
  SHL360_TASKLIST: 'SHL360: Task list',
  SHL360_START: 'SHL360: Survey start',
  SHL360_RATERLIST: 'SHL360: Rater nomination',
  SHL360_QUESTIONS: 'SHL360: Questionnaire',
  SHL360_VIEWALL: 'SHL360: View all',
  SHL360_THANKYOU: 'SHL360: Thank you',
  SHL360_SEARCH: 'SHL360: Search rater',
  SHL360_ADD_RATER: 'SHL360: Add rater',
  SHL360_PREVIEW: 'SHL360: Preview',
};

/** Events : Category */
export const GACategoryMappings: StringMap = {
  START: 'Workflow start page',
  LOGIN: 'Login page',
  RESET_PASSWORD: 'Reset password page',
  REGISTER: 'Register page',
  FORGOT_PASSWORD: 'Forgot password page',
  USER_PROFILE: 'User profile page',
  DPN: 'Data protection notice page',
  APPLICATION_FORM: 'Application Form',
  EEO: 'EEO page',
  OFCCP: 'OFCCP page',
  RESEARCH_QUESTIONS: 'Research questions page',
  YOUR_RESPONSIBILITIES: 'Your responsibilities page',
  RJP: 'RJP page',
  MINIMUM_QUALIFICATIONS: 'Minimum qualifications page',
  GENCONTENT: 'General content page',
  TASKLIST: 'Task list page',
  END: 'Experience end page',
  HURDLE_FAIL: 'Experience hurdle fail page',
  NOT_FOUND: 'Page not found page',
  ASSESSMENT: 'Experience assessment page',
  EXPVIDEOTASK: 'Experience: Video Task page',
  SHL360_LOGIN: 'SHL360: Login page',
  SHL360_TASKLIST: 'SHL360: Task list page',
  SHL360_QUES_BACK: 'SHL360: Back to previous page',
  SHL360_VIEWALL: 'SHL360: View all questionnaire page',
  SHL360_RATINGICON: 'SHL360: Rating icon',
  SHL360_THANKYOU: 'SHL360: Thank you page',
  SHL360_EXIT: 'SHL360: Exit page',
};

/** Events : Actions */
export const GAActionMappings: StringMap = {
  SIGNUP: 'Signup by experience-player',
  SIGNIN: 'Signin by experience-player',
  RESET_PASSWORD: 'Reset password',
  REGISTER: 'Register',
  FORGOT_PASSWORD: 'Forgot password',
  USER_PROFILE: 'User profile',
  DPN: 'Data protection notice',
  EEO: 'EEO',
  OFCCP: 'OFCCP',
  RESEARCH_QUESTIONS: 'Research questions',
  YOUR_RESPONSIBILITIES: 'Your responsibilities',
  RJP: 'RJP',
  MINIMUM_QUALIFICATIONS: 'Minimum qualifications',
  GENCONTENT: 'General content',
  TASKLIST: 'Task list',
  END: 'Assessment End',
  HURDLE_FAIL: 'Hurdle Fail',
  NOT_FOUND: 'Not found',
  LAUNCH_ASSESSMENT: 'Experience launch assessment',
  EXPVIDEOTASK: 'Experience: Video Task',
  SHL360_LOGIN: 'Signin by SHL360',
  SHL360_LOGIN_UNIQUE_LINK: 'Signin by SHL360 unique link',
  SHL360_LOGIN_SSO: 'Signin by SHL360 SSO',
  SHL360_TASKLIST: 'SHL360 Task: Self',
  SHL360_TASKLIST_OTHER: 'SHL360 Task: Other',
  SHL360_VIEWALL: 'SHL360 View all questionnaire',
  SHL360_RATINGICON: 'SHL360 Rating icon',
  SHL360_QUES_BACK: 'SHL360 Questionnaire back',
  SHL360_EXIT: 'SHL360 Exit questionnaire',
  SHL360_THANKYOU_REVIEW: 'SHL360 Review all responses',
  SHL360_THANKYOU_SUBMIT: 'SHL360 Save and submit',
};
